import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { notifications } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { errorNotificationsList, errorReadStatus, successNotificationsList, successReadStatus } from "../actions/notifications";
import { changeReadStatus, fetchNotificationsList } from "../api/notifications";

export function* getNoificationsList({ payload }) {
  try {
    const data = yield call(fetchNotificationsList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successNotificationsList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(errorNotificationsList(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(errorNotificationsList(err));
  }
}

export function* updateReadStatus({ payload }) {
  try {
    const data = yield call(changeReadStatus, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successReadStatus(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(errorReadStatus(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(errorReadStatus(err));
  }
}

export function* notificationsRootSaga() {
  yield takeLatest(notifications.REQUEST_NOTIFICATIONS_LIST, getNoificationsList);
  yield takeLatest(notifications.REQUEST_READ_STATUS, updateReadStatus);
}

export default function* rootSaga() {
  yield all([fork(notificationsRootSaga)]);
}
